// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2344 ? "46bdacfb" : chunkId) + "." + {"2344":"8a8a9990d1cf92e0","8764":"5c7faf39ffc3ec5d"}[chunkId] + ".js";
};